export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-formulario-raas' */ '@/views/ambulatorio/formulario-raas/Index'),
        path: 'formulario-raas',
        redirect: 'formulario-raas/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-formulario-raas' */'@/views/ambulatorio/formulario-raas/List.vue'),
                name: 'ambulatorio-formulario-raas-index',
                path: 'index',
            },
        ],
    },
]